import CryptoJS from 'crypto-js';
export const getDecryptAns = (ans) => {
  if (!ans || typeof ans !== 'string') return ans ?? '';

  try {
    const encryptedHex = ans;
    const key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_MCQ_SECRET_KEY);
    const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000');

    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Hex.parse(encryptedHex)
    });

    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);

    return decrypted || ans;
  } catch {
    // Decryption can fail for legacy/plain-text answers or mismatched keys
    return ans;
  }
};
